export default __webpack_public_path__ + "static/media/1.66be6816.png";